import * as THREE from 'three';
import { BaseCabinet } from '../base/BaseCabinet';
import { TypeCabinet } from '../../../constants/enum';
import { DecorativeModule } from '../modules/DecorativeModule';
import { TiviModule } from '../modules/TiviModule';

export class DecorativeCabinet extends BaseCabinet {
  constructor(sceneManager) {
    super(TypeCabinet.DECORATIVE, sceneManager);
    this.constraints = this.getConstraints();
  }

  getConstraints() {
    return {
      groundOffset: 0,
      wallOffset: 10,

      typePriorities: {
        low: 1,
        tall: 2,
        bench: 3,
      },

      typeHeights: {
        low: 900,   // Tủ giày thấp (mm)
        tall: 1800, // Tủ giày cao (mm)
        bench: 450, // Ghế ngồi (mm)
      },
    };
  }

  getActiveMeshPoints(cloneModule) {
    return cloneModule?.getMeshPoints?.() || [];
  }

  createModule(moduleData, moduleType, constraints) {
    if(moduleData.moduleType.toLowerCase().includes('tv')) {
      return new TiviModule(
            moduleData,
            moduleType,
            this.sceneManager,
            this,
            constraints
          );
    }else{
      return new DecorativeModule(
      moduleData,
      moduleType,
      this.sceneManager,
      this,
      constraints
    );
    }
    
  }

  setActiveEditorModuleByUuid(uuid) {
    const module = this.getModuleByGroupUuid(uuid);
    if (module) {
      this.activeEditorModule = module;
      return true;
    }
    return false;
  }
}